import { render, staticRenderFns } from "./BaseSearchableSelect.vue?vue&type=template&id=4bf48c02"
import script from "./BaseSearchableSelect.vue?vue&type=script&lang=js"
export * from "./BaseSearchableSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseSearchableSelect.vue?vue&type=style&index=0&id=4bf48c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports